export default function galleryCards() {
  const widgetName = 'galleryCards';
  const widgetOpts = galleryCardsOpts;

  const linkedImages = true;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: true,
    imageIsBackground: false,
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        $widget.find('.card-content').remove();
        changeFormatCards(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      }

      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
